import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import getConfig from 'next/config';

import { wrapper } from '@store/store';
import { fetchProducts } from '@thunks/products';

import AllProducts from '@routes/AllProducts';

import {
  getProductsMaxPage,
  prepareProductsRequestParams,
} from '@utils/filters';
import request from '@utils/request';
import { getRouteUrl } from '@utils/urls';

import { PRODUCTS_SALE } from '@common/routes';
import { OFFER_TYPES } from '@common/constants/filters';
import * as endpoints from '@common/endpoints';

const { PRODUCTS_BACKEND_URL } = getConfig().publicRuntimeConfig;

const SaleProductsPage = () => {
  const { t } = useTranslation();

  return (
    <AllProducts
      publishedOnly
      offerType={OFFER_TYPES.SALE}
      metaTitle={t('allProducts.sale.metaTitle', 'Sale')}
      pageTitle={t('allProducts.saleTitle', 'Sale')}
      pageUrl={PRODUCTS_SALE}
    />
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ query, locale }) => {
      const prefetchProducts = await request.get(endpoints.products(), {
        baseURL: PRODUCTS_BACKEND_URL,
        params: {
          limit: 1,
          offset: 0,
          publishedOnly: true,
          offerType: OFFER_TYPES.SALE,
        },
      });
      const queryPage = parseInt(query.page, 10) || 1;

      const maxPage = getProductsMaxPage(prefetchProducts, queryPage);

      const productsParams = prepareProductsRequestParams(query, {
        offerType: OFFER_TYPES.SALE,
        publishedOnly: true,
      });

      if (maxPage && queryPage && queryPage > maxPage) {
        return {
          redirect: {
            destination: getRouteUrl(
              locale,
              `${PRODUCTS_SALE}?page=${maxPage}`,
            ),
            permanent: false,
          },
        };
      }

      await store.dispatch(fetchProducts(productsParams));

      return {
        props: {
          ...(await serverSideTranslations(locale)),
        },
      };
    },
);

export default SaleProductsPage;
